import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface Country {
  name: string;
  sigla: string;
  ddi: string;
  mask: string;
  flag?: string;
}

export const paises: Country[] = [
  { name: 'Brasil', sigla: 'BR', ddi: '55', mask: '(00) 00000-0000', flag: '🇧🇷' },
  { name: 'Paraguai', sigla: 'PY', ddi: '595', mask: '000 000000', flag: '🇵🇾' },
  { name: 'Argentina', sigla: 'AR', ddi: '54', mask: '00 0000-0000', flag: '🇦🇷' },
  { name: 'Chile', sigla: 'CL', ddi: '56', mask: '00 0000 0000', flag: '🇨🇱' },
  { name: 'Uruguai', sigla: 'UY', ddi: '598', mask: '00 000 0000', flag: '🇺🇾' },
  { name: 'Colômbia', sigla: 'CO', ddi: '57', mask: '000 000 0000', flag: '🇨🇴' },
  { name: 'Bolívia', sigla: 'BO', ddi: '591', mask: '000 000000', flag: '🇧🇴' },
  { name: 'Peru', sigla: 'PE', ddi: '51', mask: '000 000 000', flag: '🇵🇪' },
  { name: 'Equador', sigla: 'EC', ddi: '593', mask: '00 000 0000', flag: '🇪🇨' },
  { name: 'Venezuela', sigla: 'VE', ddi: '58', mask: '0000-0000000', flag: '🇻🇪' },
  { name: 'Guiana', sigla: 'GY', ddi: '592', mask: '000-0000', flag: '🇬🇾' },
  { name: 'Suriname', sigla: 'SR', ddi: '597', mask: '000-0000', flag: '🇸🇷' },
  { name: 'Guiana Francesa', sigla: 'GF', ddi: '594', mask: '00000 0000', flag: '🇬🇫' }
];


@Component({
  selector: 'app-country-dialog',
  imports: [],
  templateUrl: './country-dialog.html',
  styleUrl: './country-dialog.scss',
})
export class CountryDialog {
  countries = paises;
  constructor(private dialogRef: MatDialogRef<CountryDialog>) {}

  onCountrySelected(country: Country) {
    this.dialogRef.close(country);
  }
}
